// ResidentMenuPage.jsx
import React, { use, useEffect, useState } from "react";
import { Grid, Typography, Button, Paper } from "@material-ui/core";
import LeftNav from "./LeftNav"; // Import LeftNav component
import { useHistory } from "react-router-dom";
import { fetchMenu } from "../../services/api/si180Api";

const primColor = process.env.REACT_APP_SI180_PRIMCOLOR;
const textColor = process.env.REACT_APP_TEXT_COLOR;
const btnColor = process.env.REACT_APP_SI180_BTNCOLOR;
const greyColor = process.env.REACT_APP_SI180_BGGREY;
const siteMedSrc = process.env.REACT_APP_MEDIA_SRC;
const secColor = process.env.REACT_APP_SI180_SECCOLOR;

const ResidentMenuPage = ({ onResidentLookup }) => {
  // Accept onResidentLookup as a prop
  const [checkNumber, setCheckNumber] = useState("12345"); // Example check number, update as necessary
  const history = useHistory();
  const [currentUser, setCurrentUser] = useState({
    firstName: JSON.parse(sessionStorage.getItem("selectedCustomer")).FirstName,
    lastName: JSON.parse(sessionStorage.getItem("selectedCustomer")).LastName,
  });

  const [menu, setMenu] = useState([]);

  useEffect(async () => {
    try {
      const data = await fetchMenu();
      setMenu(data);
    } catch (error) {
      console.error("fetchMenu failed:", error);
    }
  }, []);

  return (
    <div className="dashboard">
      <LeftNav onResidentLookup={onResidentLookup} />{" "}
      {/* Only pass the relevant navigation handler */}
      <div className="right-pane">
        {/* Resident Name */}
        <Typography
          variant="h4"
          style={{ textAlign: "center", color: primColor }}
        >
          Order for {currentUser.firstName} {currentUser.lastName}
        </Typography>

        {/* Menu Items */}
        <Grid
          container
          spacing={2}
          justify="center"
          style={{ marginTop: 20, textAlign: "center" }}
        >
          {menu.map((m) => (
            <Grid item key={m.SIC_ID} xs={12} sm={6} md={4} lg={4}>
              <Paper
                style={{
                  padding: 10,
                  backgroundColor: btnColor,
                  cursor: "pointer",
                }}
                onClick={() => {
                  sessionStorage.setItem("selectedMenu", m.MenuName);
                  history.push("/resident-items");
                }}
              >
                <Typography
                  variant="h5"
                  style={{ color: textColor, textAlign: "center" }}
                >
                  {m.MenuName}
                </Typography>
                {/* Check Number */}
                <Typography
                  variant="h7"
                  style={{
                    textAlign: "center",
                    // marginTop: 20,
                    color: textColor,
                  }}
                >
                  Check Number: {checkNumber}
                </Typography>

                {/* Placeholder for meal image */}
                <div style={{ textAlign: "center", margin: "10px 0" }}>
                  <img
                    src={`${siteMedSrc}${m.MenuName.toLowerCase()}.png`}
                    alt={m.MenuName}
                    onError={(e) => {
                      e.target.onerror = null; // Disable onError after one trigger
                      e.target.src = siteMedSrc + "empty-img.png"; // Set fallback image path
                    }}
                    style={{
                      width: "500px",
                      height: "300px",
                      objectFit: "cover",
                    }}
                  />
                </div>
              </Paper>
            </Grid>
          ))}
        </Grid>

        {/* Send Order Button */}
        {/* <div style={{ textAlign: "center", marginTop: 20 }}>
          <Button
            className="si180btn"
            variant="contained"
            style={{
              backgroundColor: btnColor,
              color: textColor,
            }}
            type="submit"
          >
            Send Order
          </Button>
        </div> */}
      </div>
    </div>
  );
};

export default ResidentMenuPage;
